(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account','AnagraficaService'];

    function Principal ($q, Account, AnagraficaService) {
        var _identity,
            _authenticated = false,
            _logout = {logout: false},
        	_mustConfirmEmail = null;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            isLogout: isLogout,
            setLogout: setLogout,
            needPersonalMailConfirmation: needPersonalMailConfirmation,
            setPersonalMailConfirmation: setPersonalMailConfirmation
        };

        return service;
        
        function setPersonalMailConfirmation(flag){
        	_mustConfirmEmail = flag;
        }
        
        function needPersonalMailConfirmation(){
        	if(_mustConfirmEmail == null)
        		return false;
        	return _mustConfirmEmail;
        }

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }
        
        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                setLogout( false);
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                setLogout( false)
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }
        
        function isLogout () {
            return _logout;
        }
        
        function setLogout (logout) {
            _logout.logout = logout;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
